import React, { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import Toast from '../component/toast';
import { alertNull } from '../context/actions/toastAction'; // Assuming this action clears the toast state

const ToastGlobal = () => {
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  useEffect(() => {
    if (toast?.type) {
      // Trigger the toast with type and message
      Toast(toast);

      // Clear the toast after it's shown
      setTimeout(() => {
        dispatch(alertNull());
      }, 3000); // Optional: Adjust the timeout to clear the toast after 3 seconds
    }
  }, [toast, dispatch]);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
};

export default ToastGlobal;
